import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { characterApi } from '../api/character-api';
import type { CharacterApi } from '../types/character.types';
import { CharacterController } from '../stores/character-controller';
import { useCharacterPresence } from './use-character-presence';
export function useHeroCharacter({
  heroId,
  api = characterApi,
}: {
  heroId: number | null;
  api?: CharacterApi;
}) {
  const controller = useMemo(
    () => new CharacterController(heroId, api),
    [heroId, api],
  );
  const state = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot,
  );
  useEffect(() => {
    controller.start();
    return controller.stop;
  }, [controller]);
  useCharacterPresence({ heroId, enabled: state.snapshot !== null && !state.unavailable });
  return {
    ...state,
    loadJournal:controller.loadJournal,
dismissDecision: controller.dismissDecision,
    refresh: controller.refresh,
    advise: controller.advise,
    retry: controller.retry,
    applySnapshot: controller.applySnapshot,
    applyAdvice: controller.applyAdvice,
    applyDecision: controller.applyDecision,
  };
}
export type HeroCharacterController = ReturnType<typeof useHeroCharacter>;
